import { useGetTechsOnMount } from '@user/store/techs'
import { useGetTechRegionsOnMount } from '@user/store/techRegions'
import { useGetLeadOppProductsOnMount } from '@user/store/leadOppProducts'
import { useLoadEntityLocationsOnMount } from '@user/store/entityLocations'

import { useSchedulingWizard } from '../wizardContext'
import { useCheckCloseOnSchedule } from './useCheckCloseOnSchedule'
import { useLeadScheduleAutoClose } from './useLeadScheduleAutoClose'

export function useData() {
  const [{ entityId, entityType }] = useSchedulingWizard()

  const techsLoading = useGetTechsOnMount()
  const regionsLoading = useGetTechRegionsOnMount()
  const svcStatus = useGetLeadOppProductsOnMount(entityId, entityType)
  const locStatus = useLoadEntityLocationsOnMount(entityId, entityType)
  const closeableLoading = useCheckCloseOnSchedule({ entityId, entityType })
  const { isLoading: leadAutoCloseLoading } = useLeadScheduleAutoClose()

  const loading =
    techsLoading ||
    regionsLoading ||
    closeableLoading ||
    leadAutoCloseLoading ||
    locStatus === 'pending' ||
    svcStatus === 'pending'

  return loading
}
